import {useEffect, useRef, useState} from 'react'
import {Box, Image, Text, Flex, Center} from '@chakra-ui/react'
import BackgroundSituation from '@assets/images/revise/situation.png'
import BackgroundSituationBlur from '@assets/images/revise/situation-blur.png'
import PlayIcon from '@assets/svgs/revise/play.svg'
import PlaySlowIcon from '@assets/svgs/revise/play_slow.svg'
import PauseAudioIcon from '@assets/svgs/revise/pause.svg'
import FemaleImageBig from '@assets/images/revise/female-big.png'
import MaleImageBig from '@assets/images/revise/male-big.png'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateCurrentTimeAudio,
  updateIsDisableReply,
  updateIsOpenSubTitle,
  updateIsShowHeaderBtn,
  updateStatusHeaderBtn,
} from '@redux/revise/revise'
import useExamRoom from './useExamRoom'

const VideoCustom = ({
  isIntro,
  px,
  py,
  fontSize,
}: {
  isIntro: boolean
  px: any
  py: any
  fontSize: any
}) => {
  const {currentQuestion, currentTimeAudio, audioUrl} = useSelector(
    (state: any) => state.revise,
  )
  const [isShowIntro, setIsShowIntro] = useState(isIntro)
  const [isPlayAudio, setIsPlayAudio] = useState(false)
  const [isPlayQuestionAudio, setIsPlayQuestionAudio] = useState(true)
  const [isSlowAudio, setIsSlowAudio] = useState(false)
  const [isAllowSeek, setSsAllowSeek] = useState(false)
  const [isMale, setIsMale] = useState(false)
  const [transcript, setTranscript] = useState('')
  const [audioTime, setAudioTime] = useState<any>({})
  const audioRef = useRef<any>(null)
  const progressAudioRef = useRef<any>(null)
  const dispatch = useDispatch()
  const audioWrapElement = document.querySelector(
    '.video-custom-revise',
  ) as HTMLElement
  const {handlePlayAudio, handlePauseAudio} = useExamRoom()

  useEffect(() => {
    if (!audioUrl) {
      return
    }
    audioRef.current = new Audio(audioUrl)
    audioRef.current.addEventListener('loadedmetadata', function () {
      const duration = Math.round(audioRef.current.duration)
      setAudioTime({...audioTime, duration})
    })
    audioRef.current.addEventListener('timeupdate', function () {
      const duration = Math.round(audioRef.current.duration)
      const currentTime = Math.round(audioRef.current.currentTime)
      setAudioTime({currentTime, duration})
      dispatch(updateCurrentTimeAudio(currentTime))
    })
    audioRef.current.addEventListener('ended', function () {
      setSsAllowSeek(true)
      dispatch(updateIsDisableReply(false))
      dispatch(updateIsOpenSubTitle(true))
    })
    const audioTimeout = setTimeout(() => {
      if (
        currentQuestion.type !== 'LV2_LISTEN_CONVERSATION' &&
        currentQuestion.type !== 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT'
      ) {
        setIsPlayAudio(true)
      }
    }, 2000)
    return () => {
      clearTimeout(audioTimeout)
      if (audioRef.current) {
        audioRef.current.removeEventListener('ended', () => {})
      }
    }
  }, [audioUrl])

  useEffect(() => {
    if (!audioWrapElement) {
      return
    }
    audioWrapElement.addEventListener('myCustomEvent', function (e: any) {
      const time = Number(e.detail)
      if (isFinite(time)) {
        audioRef.current.currentTime = time
      }
    })
  }, [audioWrapElement])

  useEffect(() => {
    if (
      currentQuestion.type !== 'LV2_LISTEN_CONVERSATION' &&
      currentQuestion.type !== 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT'
    ) {
      setSsAllowSeek(false)
      setIsPlayQuestionAudio(true)
      audioRef.current.currentTime = currentQuestion.data.start_time || 0
    }
    const handleTimeUpdate = () => {
      const currentTime = audioRef.current.currentTime
      if (
        currentQuestion.type !== 'LV2_LISTEN_CONVERSATION' &&
        currentQuestion.type !== 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT' &&
        currentTime + 1 >= currentQuestion.data.end_time
      ) {
        setIsPlayAudio(false)
        setSsAllowSeek(true)
        dispatch(updateIsDisableReply(false))
        dispatch(updateIsOpenSubTitle(true))
        audioRef.current.currentTime = currentQuestion.data.start_time
      } else {
        if (currentTime + 1 >= Math.round(currentQuestion.data.end_time)) {
          setSsAllowSeek(true)
          dispatch(updateStatusHeaderBtn('complete'))
        }
        if (audioRef.current.currentTime >= audioRef.current.duration) {
          setIsPlayAudio(false)
        }
      }
    }
    audioRef.current.addEventListener('timeupdate', handleTimeUpdate)
    const audioTimeout = setTimeout(() => {
      if (
        currentQuestion.type !== 'LV2_LISTEN_CONVERSATION' &&
        currentQuestion.type !== 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT'
      ) {
        setIsPlayAudio(true)
      }
    }, 2000)
    return () => {
      clearTimeout(audioTimeout)
      audioRef.current.removeEventListener('timeupdate', handleTimeUpdate)
    }
  }, [currentQuestion])

  useEffect(() => {
    if (!audioRef.current) {
      return
    }
    if (isPlayAudio) {
      handlePauseAudio()
      audioRef.current.play()
    } else {
      audioRef.current.pause()
    }

    return () => {
      audioRef.current.pause()
    }
  }, [isPlayAudio, audioRef.current])

  useEffect(() => {
    if (isSlowAudio) {
      audioRef.current.playbackRate = 0.5
    } else {
      audioRef.current.playbackRate = 1
    }
  }, [isSlowAudio])

  useEffect(() => {
    currentQuestion?.data.timeline?.forEach((item: any) => {
      if (
        currentTimeAudio >= item.start_time.toFixed(0) &&
        currentTimeAudio < item.end_time.toFixed(0)
      ) {
        if (item.character_gender === 'male') {
          setIsMale(true)
        } else {
          setIsMale(false)
        }
      }
    })

    const currentTime = Math.round(audioRef.current.currentTime)
    if (
      currentQuestion.type !== 'LV2_LISTEN_CONVERSATION' &&
      currentQuestion.type !== 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT' &&
      currentTime >= Math.round(currentQuestion.data.end_time)
    ) {
      setTimeout(() => {
        if (isPlayQuestionAudio) {
          handlePlayAudio(currentQuestion.data.audio)
          setIsPlayQuestionAudio(false)
        }
      }, 1500)
    }

    if (
      (currentQuestion.type === 'LV2_LISTEN_CONVERSATION' ||
        currentQuestion.type === 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT') &&
      audioTime.currentTime >= 10
    ) {
      dispatch(updateIsShowHeaderBtn(true))
    }
  }, [currentTimeAudio, currentQuestion])

  useEffect(() => {
    if (currentQuestion.type !== 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT') {
      return
    }
    currentQuestion?.data.timeline.forEach((item: any) => {
      if (
        currentTimeAudio >= item.start_time.toFixed(0) &&
        currentTimeAudio < item.end_time.toFixed(0)
      ) {
        setTranscript(item.transcript)
      }
    })
  }, [currentTimeAudio])

  const handleClickIntro = () => {
    setIsShowIntro(false)
    setTimeout(() => {
      setIsPlayAudio(true)
    }, 1000)
  }

  const handleClickPlayAudio = () => {
    setIsPlayAudio(!isPlayAudio)
  }

  const handleClickSlowAudio = () => {
    setIsSlowAudio(!isSlowAudio)
  }

  const handleClickProgressAudio = (e: any) => {
    if (!isAllowSeek) {
      return
    }
    const {offsetX} = e.nativeEvent
    const width = progressAudioRef.current.offsetWidth
    const percent = offsetX / width
    const timeResult = audioTime.duration * percent
    if (
      currentQuestion.type !== 'LV2_LISTEN_CONVERSATION' &&
      currentQuestion.type !== 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT' &&
      (timeResult < currentQuestion.data.start_time ||
        timeResult >= currentQuestion.data.end_time)
    ) {
      return
    }
    audioRef.current.currentTime = timeResult
  }

  return (
    <Box
      className="video-custom-revise"
      css={{
        '&:hover > .controller': {
          opacity: 1,
        },
        '&:hover > .video-title': {
          opacity: 1,
        },
      }}
      w={'100%'}
      h={'100%'}
      position={'relative'}
      bgImage={isShowIntro ? BackgroundSituation : BackgroundSituationBlur}
      bgRepeat={'no-repeat'}
      bgSize={'cover'}>
      {isShowIntro && (
        <Center
          flexDirection={'column'}
          w={'100%'}
          px={'16px'}
          position={'absolute'}
          top={'50%'}
          left={'50%'}
          transform={'translate(-50%, -50%)'}>
          {currentQuestion.type ===
            'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT' && (
            <Text
              fontSize={'16px'}
              fontWeight={600}
              maxW={'446px'}
              color={'#fff'}
              align={'center'}>
              🌟 Bạn đã làm rất tốt 🌟
            </Text>
          )}
          <Text
            fontSize={'16px'}
            fontWeight={600}
            w={'100%'}
            maxW={'446px'}
            color={'#fff'}
            align={'center'}>
            {currentQuestion.type === 'LV2_LISTEN_CONVERSATION' &&
              'Hãy nghe và thử đoán nội dung của cuộc trò chuyện sau trước khi chuyển sang làm bài tập'}
            {currentQuestion.type ===
              'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT' &&
              'Giờ hãy xem lại tình huống tiếng Việt để hiểu rõ tình huống vừa rồi nha!'}
          </Text>
          <Center
            cursor={'pointer'}
            w={'72px'}
            h={'72px'}
            mt={'24px'}
            borderRadius={'50%'}
            border={'1px solid #fff'}
            bg={'rgba(255, 255, 255, 0.40)'}
            onClick={handleClickIntro}>
            <Image src={PlayIcon} />
          </Center>
        </Center>
      )}
      {!isShowIntro && (
        <Flex
          className="video-title"
          position={'absolute'}
          transition={'0.3s'}
          opacity={
            currentQuestion.type === 'LV2_LISTEN_CONVERSATION' ||
            currentQuestion.type === 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT'
              ? 0
              : 1
          }
          zIndex={2}
          top={0}
          px={px}
          pt={py}
          w={'100%'}
          h={'200px'}
          color={'white'}
          flexDirection={'column'}
          bg={
            'linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.20) 31.45%, rgba(0, 0, 0, 0.00) 56.13%)'
          }>
          <Text
            textShadow={'2px 2px 4px rgba(0, 0, 0, 0.5)'}
            fontSize={fontSize === '16px' ? '12px' : '16px'}
            fontWeight={600}>
            {currentQuestion.type === 'LV2_LISTEN_CONVERSATION'
              ? 'Nghe và trả lời'
              : 'Tình huống'}
          </Text>
          <Text
            fontSize={fontSize}
            fontWeight={600}
            textShadow={'2px 2px 4px rgba(0, 0, 0, 0.5)'}>
            Làm quen với bạn mới
          </Text>
        </Flex>
      )}
      {!isShowIntro && (
        <Flex
          className="controller"
          transition={'0.3s'}
          opacity={
            currentQuestion.type === 'LV2_LISTEN_CONVERSATION' ||
            currentQuestion.type === 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT'
              ? 0
              : 1
          }
          position={'absolute'}
          zIndex={10}
          px={px}
          pb={py}
          bottom={0}
          w={'100%'}
          h={'200px'}
          gap={'16px'}
          alignItems={'end'}
          bg={
            'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.20) 31.45%, rgba(0, 0, 0, 0.00) 56.13%)'
          }>
          <Center w={'24px'} h={'24px'}>
            <Image
              w={isPlayAudio ? '16px' : '24px'}
              h={isPlayAudio ? '16px' : '24px'}
              cursor={'pointer'}
              src={isPlayAudio ? PauseAudioIcon : PlayIcon}
              onClick={handleClickPlayAudio}
            />
          </Center>

          <Flex flex={1} flexDirection={'column'} gap={'8px'}>
            <Flex color={'white'} justifyContent={'space-between'}>
              <TimeDisplay totalSeconds={audioTime.currentTime || 0} />
              <TimeDisplay totalSeconds={audioTime.duration} />
            </Flex>
            <Box
              ref={progressAudioRef}
              position={'relative'}
              h={'8px'}
              mb={'8px'}
              borderRadius={'100px'}
              bg={'rgba(245, 245, 245, 0.24)'}
              cursor={isAllowSeek ? 'pointer' : 'unset'}
              _hover={{
                '.progress-line': {},
              }}
              onClick={handleClickProgressAudio}>
              <Box
                display={isAllowSeek ? 'block' : 'none'}
                className="progress-audio"
                pointerEvents={'none'}
                transition={'0.3s'}
                left={`${(audioTime.currentTime / audioTime.duration) * 100 || 0}%`}
                w={'12px'}
                h={'12px'}
                borderRadius={'50%'}
                bg={'white'}
                position={'absolute'}
                top={'50%'}
                zIndex={2}
                cursor={isAllowSeek ? 'pointer' : 'unset'}
                transform={'translate(-50%, -50%)'}></Box>
              <Box
                transition={'0.3s'}
                className="progress-line"
                position={'absolute'}
                top={'50%'}
                transform={'translateY(-50%)'}
                h={'100%'}
                bg={'white'}
                borderRadius={'100px'}
                w={`${(audioTime.currentTime / audioTime.duration) * 100 || 0}%`}></Box>
            </Box>
          </Flex>
          <Flex role="group" position={'relative'} justifyContent={'center'}>
            <Image
              w={'24px'}
              h={'24px'}
              cursor={'pointer'}
              opacity={isSlowAudio ? 1 : 0.5}
              src={PlaySlowIcon}
              onClick={handleClickSlowAudio}
            />
            <Text
              borderRadius={'2px'}
              align={'center'}
              p={'6px 8px'}
              bg={'#595959'}
              position={'absolute'}
              top={'-45px'}
              color={'white'}
              w={'115px'}
              display={'none'}
              _groupHover={{display: 'block'}}>
              {isSlowAudio ? 'Tắt nghe chậm' : 'Nghe chậm'}
            </Text>
          </Flex>
        </Flex>
      )}
      {!isShowIntro && (
        <>
          <Image
            position={'absolute'}
            zIndex={1}
            h={'85%'}
            bottom={0}
            right={'55%'}
            filter={isMale ? 'grayscale(100%)' : 'unset'}
            src={FemaleImageBig}
          />
          <Image
            position={'absolute'}
            zIndex={1}
            h={'85%'}
            bottom={0}
            left={'55%'}
            filter={isMale ? 'unset' : 'grayscale(100%)'}
            src={MaleImageBig}
          />
        </>
      )}
      {currentQuestion.type === 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT' &&
        !isShowIntro && (
          <Box
            position={'absolute'}
            zIndex={3}
            w={'100%'}
            maxW={'500px'}
            bottom={'80px'}
            left={'50%'}
            transform={'translateX(-50%)'}>
            <Text
              align={'center'}
              fontSize={'24px'}
              color={'white'}
              textShadow={'2px 2px 4px rgba(0, 0, 0, 0.5)'}>
              {transcript}
            </Text>
          </Box>
        )}
    </Box>
  )
}

const TimeDisplay = ({totalSeconds}: {totalSeconds: any}) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return (
    <Text
      fontSize={'12px'}
      fontWeight={500}
      style={{
        textWrap: 'nowrap',
      }}>
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </Text>
  )
}

export default VideoCustom
